import { useMemo } from "react";
import { Box } from "@mui/material";

import { useAppSelector } from "utils/redux/hooks";
import { selectCurrentUserInfo } from "app/containers/Global/slice";
import {
  COACH_BO_DAY_MESSAGES,
  getDayOfWeek,
} from "app/containers/Dashboard/coachBoWelcomeMessages";
import robot from "resources/images/robot.png";

import { ActivityHeaderSectionLayout } from "../../layer31";

const getTimeOfDayGreeting = (hour: number) => {
  if (hour >= 5 && hour < 12) return "Good morning";
  if (hour >= 12 && hour < 17) return "Good afternoon";
  return "Good evening";
};

export const BoZoneActivityHeaderSection = () => {
  const currentUserInfo = useAppSelector(selectCurrentUserInfo);
  const firstName = currentUserInfo?.firstName;

  const greeting = getTimeOfDayGreeting(new Date().getHours());

  const subtitle = useMemo(() => {
    // Date.getDay() returns 0 for Sunday, but getDayOfWeek expects 7.
    const dayName = getDayOfWeek(new Date().getDay() || 7);
    const messages = COACH_BO_DAY_MESSAGES[dayName] ?? [];
    const randomMessage =
      messages[Math.floor(Math.random() * messages.length)]?.message; // NOSONAR: non-security use, rotating greeting copy
    return randomMessage?.replace("$f_name", firstName ?? "");
  }, [firstName]);

  return (
    <ActivityHeaderSectionLayout
      title={firstName ? `${greeting}, ${firstName}!` : `${greeting}!`}
      icon={
        <Box
          component="img"
          src={robot}
          alt="coach-bo"
          sx={{
            width: "3.5rem",
            height: "3.5rem",
          }}
        />
      }
      subtitle={subtitle}
    />
  );
};
